import script from "./DownloadInMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadInMobile.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadInMobile.vue?vue&type=style&index=0&id=26b20fba&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26b20fba"]])

export default __exports__